__turbopack_context__.v({
  "company_grid": "step-profile-module-scss-module__owJ7ta__company_grid",
  "credentials_grid": "step-profile-module-scss-module__owJ7ta__credentials_grid",
  "exists_warning": "step-profile-module-scss-module__owJ7ta__exists_warning",
  "header_slot": "step-profile-module-scss-module__owJ7ta__header_slot",
  "link": "step-profile-module-scss-module__owJ7ta__link",
  "profile_grid": "step-profile-module-scss-module__owJ7ta__profile_grid",
  "required": "step-profile-module-scss-module__owJ7ta__required",
  "root": "step-profile-module-scss-module__owJ7ta__root",
  "separator": "step-profile-module-scss-module__owJ7ta__separator",
  "warning_icon": "step-profile-module-scss-module__owJ7ta__warning_icon",
});
